<template>
    <div class="main">
        <div class="search-box">
            <input type="text" class="header-input fl" v-model="searchInput" placeholder="请输入内容"
                   @keydown.enter="searchGood"/>
            <button class="header-button fl" @click="searchGood()">搜索</button>
        </div>
        <ul class="pool-box" ref="goodList">
            <li class="shop-message fl" v-for="(item, index) in goodList" :key="index">
                <div class="goods-png">
                    <img :src="item.img">
                </div>
                <p class="good-message" v-text="item.name"></p>
                <div>
                    <div class="foot-left fl">
                        <p class="fl preferential">优惠价：</p>
                        <p class="fl preferential-money">￥{{showPrice(item.jdDisPrice)}}</p>
                        <div class="clear"></div>
                        <p class="jd-price fl">京东售价：</p>
                        <p class="jd-money fl">￥{{showPrice(item.jdPrice)}}</p>
                    </div>
                    <button class="grow-button fr " @click="addGood(item.skuId)">添加</button>
                </div>
            </li>
            <li class="bottom fl">
                <span v-if="goodList.length > 0 && noMore">到底了...</span>
                <span v-if="goodList.length === 0 && noMore">没有搜索到商品</span>
            </li>
        </ul>
    </div>
</template>

<script>
  import {getGoodsPool} from '@/api/shop.js'
  import {clearG, setGstore, getGstore} from "@/utils/storage";

  export default {
    name: "goodsPool",
    data() {
      return {
        goodList: [],
        searchInput: '',
        searchcontent: '',
        page: 1,
        isAchiveBottom: false,
        noMore: false
      }
    },
    mounted() {
      this.getGoodList()
      this.$refs['goodList'].onscroll = (event) => {
        const dom = event.target
        //变量scrollTop是滚动条滚动时，距离顶部的距离
        let scrollTop = dom.scrollTop;
        //变量windowHeight是可视区的高度
        let windowHeight = dom.clientHeight;
        //变量scrollHeight是滚动条的总高度
        let scrollHeight = dom.scrollHeight;
        //滚动条到底部的条件(距底部20px时触发加载)
        if (scrollTop + windowHeight >= scrollHeight - 20 &&
          !this.isAchiveBottom &&
          !this.noMore
        ) {
          console.log('------------')
          this.page = this.page + 1;
          this.getGoodList()
        }
      }
    },
    methods: {
      addGood(skuId){
        this.$store.state.isTable = false;
        this.$router.push({
          path: '/addGood',
          query:{
            skuId: skuId
          }
        })
      },
      getGoodList() {
        this.isAchiveBottom = true;
        getGoodsPool({
          page: this.page,
          pageCount: 10,
          search: this.searchcontent
        }).then((res) => {
          this.isAchiveBottom = false;
          if (res.data.length === 0) {
            return this.noMore = true;
          } else {
            this.goodList = this.goodList.concat(res.data);
          }
        })
      },
      showPrice(price){
        return (price  / 100).toFixed(2)
      },
      searchGood() {
        this.noMore = false;
        this.page = 1;
        this.goodList = [];
        this.searchcontent = this.searchInput;
        this.getGoodList()
      }
    }
  };
</script>

<style scoped lang="scss">
    .fr {
        float: right;
    }

    .clear {
        clear: both;
    }

    .fl {
        float: left;
    }

    .main {
        width: 99.8%;
        min-width: 1100px;
        background: #ffffff;
        height: calc(100% - 100px);
    }

    .search-box {
        width: 700px;
        margin: 34px auto 0;
        height: 45px;
    }

    .header-input {
        width: 600px;
        height: 44px;
        background: #ffffff;
        border: 1px solid #2479ed;
        border-radius: 4px 0px 0px 4px;
        text-indent: 20px;
    }

    .header-button {
        cursor: pointer;
        width: 98px;
        height: 44px;
        background: #2479ed;
        border: 2px solid #2479ed;
        border-radius: 0px 6px 6px 0px;
        font-size: 14px;
        font-weight: 500;
        color: #ffffff;
    }

    .pool-box {
        width: 98.5%;
        margin-top: 30px;
        margin-left: 1.5%;
        overflow: auto;
        height: calc(100% - 140px);
    }

    .bottom{
        width: 100%;
        text-align: center;
        font-size: 14px;
        margin: 20px 0;
    }

    .shop-message {
        width: 242px;
        height: 346px;
        border: 1px solid #e5e5e5;
        border-radius: 4px;
        margin-left: 1%;
        margin-top: 24px;
    }

    .goods-png {
        margin-top: 20px;
        width: 202px;
        height: 202px;
        margin-left: 20px;
        background-color: #616161;

        img {
            height: 100%;
            width: 100%;
        }
    }


    .good-message {
        margin: 0 20px;
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #333333;
        line-height: 22px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
    }

    .foot-left {
        margin-left: 20px;
        width: 153px;
        font-size: 12px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #666666;
        line-height: 19px;
    }

    .foot-right {
        width: 69px;
    }

    .preferential {
        margin-top: 17px;
    }

    .preferential-money {
        color: #ff3300;
        font-size: 16px;
        margin-top: 17px;
    }

    .jd-price {
        margin-top: 7px;
    }

    .jd-money {
        margin-top: 7px;
    }

    .grow-button {
        cursor: pointer;
        margin-top: 27px;
        margin-right: 20px;
        width: 45px;
        height: 22px;
        background: #2479ed;
        color: #ffffff;
    }
</style>
